import firebase from 'firebase/app'
import 'firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyBPPXk17ZsEF8VQoQI9MiMpVxtdr7MIFRU",
  authDomain: "bodensee-buggy-by-max.firebaseapp.com",
  databaseURL: "https://bodensee-buggy-by-max.firebaseio.com",
  projectId: "bodensee-buggy-by-max",
  storageBucket: "bodensee-buggy-by-max.appspot.com",
  messagingSenderId: "121908718790",
  appId: "1:121908718790:web:c8a81d6ae5ce3c2b8cfbc7",
  measurementId: "G-HKTRZ7FGVF"
};

// Get a Firestore instance
export const db = firebase
  .initializeApp(firebaseConfig)
  .firestore()

// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples
const { TimeStamp, GeoPoint } = firebase.firestore
export { TimeStamp, GeoPoint }

// if using Firebase JS SDK < 5.8.0
//db.settings({ timestampsInSnapshots: true })
